import Swiper, { Navigation, Pagination, A11y } from 'swiper';

export default () => {
	// awards slider
	const awardsSwiper = new Swiper('.awards-wrap', {
		modules: [Navigation, Pagination, A11y],
		pagination: {
			el: '#awards-part .swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '#awards-part .arrow-next',
			prevEl: '#awards-part .arrow-prev',
		},
		a11y: true,
		keyboardControl: true,
		grabCursor: true,
		watchOverflow: true,
		loop: false,
		breakpoints: {
			360: {
				slidesPerView: 1,
				navigation: false,
			},
			414: {
				slidesPerView: 2,
				navigation: false,
			},
			768: {
				slidesPerView: 3,
				navigation: false,
			},
			992: {
				slidesPerView: 4,
			},
			1200: {
				slidesPerView: 4,
				pagination: false,
			},
			1440: {
				slidesPerView: 4,
				pagination: false,
			},
		},
	});
};
